'use client';

import { useOverlayTriggerState } from '@react-stately/overlays';
import { useAuth } from 'react-oidc-context';

import { Mug } from '@zoomit/icons';
import { cssVar, Flex, Link } from '@zoomit/primitives';
import { onMenuClick, OriginURL, UnauthorizedModal } from '@zoomit/web-kit';
import { theme, Typography } from '@zoomit/zoomit-ds';

import { useWebKitCustomization } from '../../../hooks/useWebKitCustomization';

const MyProfileDetail = () => {
  const tenantPersianTitle = useWebKitCustomization((state) => state.tenantPersianTitle);

  return (
    <Flex
      className={'relative h-full'}
      flexDirection={'column'}
      alignItems={'center'}
      gap={0.4}
      justifyContent={'end'}
    >
      <Mug fill={cssVar(theme.primary1)} />
      <Typography
        className={'group-hover:text-primary1 transition duration-150'}
        lineHeight={'26px'}
        fontWeight={700}
      >
        {tenantPersianTitle} من
      </Typography>
    </Flex>
  );
};

export const MyProfileSection = () => {
  const { isAuthenticated, user } = useAuth();

  const unauthorizedModal = useOverlayTriggerState({});

  const tenantPersianTitle = useWebKitCustomization((state) => state.tenantPersianTitle);
  const basePath = useWebKitCustomization((state) => state.basePath);
  const urlBasePath = basePath ? OriginURL : '';

  return isAuthenticated ? (
    <Link
      className={'group h-full'}
      onClick={() => {
        onMenuClick({ menu: `${tenantPersianTitle} من`, device: 'desktop' });
      }}
      href={
        user?.profile?.isAuthor
          ? `${urlBasePath}/author/${user?.profile.sub}`
          : `${urlBasePath}/profile/${user?.profile.sub}`
      }
    >
      <MyProfileDetail />
    </Link>
  ) : (
    <div className={'group h-full cursor-pointer'} onClick={() => unauthorizedModal.open()}>
      <MyProfileDetail />
      <UnauthorizedModal isOpen={unauthorizedModal.isOpen} onClose={() => unauthorizedModal.close()} />
    </div>
  );
};
